<template>
  <b-tab id="tab-left-1" title="รายละเอียดเรื่องแจ้งเบาะแส">
    <div>
      <h2>{{ clueData.clueCode }}</h2>
    </div>
    <b-card body-border-variant="primary" body-class="rounded">
      <b-col cols="12">
        <b-form-group label="ผู้ประกอบธุรกิจ">
          <b-form-input
            v-model="clueData.compName"
            placeholder="ผู้ประกอบธุรกิจ"
            :readonly="isReadonly ? 'readony' : ''"
            class="col-12"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group label="ที่อยู่/รายละเอียด ผู้ประกอบธุรกิจ">
          <b-form-textarea
            v-model="clueData.compDetail"
            placeholder="ที่อยู่/รายละเอียด ผู้ประกอบธุรกิจ"
            :readonly="isReadonly ? 'readony' : ''"
            rows="5"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group label="รายละเอียดการกระทำผิด">
          <b-form-textarea
            v-model="clueData.clueDetail"
            placeholder="รายละเอียดการกระทำผิด"
            :readonly="isReadonly ? 'readony' : ''"
            rows="5"
          />
        </b-form-group>
      </b-col>
    </b-card>

    <b-card
      title="ที่อยู่ที่สามารถติดต่อได้"
      body-border-variant="primary"
      body-class="rounded"
    >
      <b-row>
        <b-col cols="12">
          <b-form-group label="ที่ตั้ง/ที่อยู่">
            <CompanyAddress
              v-if="address !== null && address !== undefined"
              :address="address"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="facebook ของผู้กระทำความผิด (ถ้ามี)">
            <b-form-input
              v-model="clueData.facebook"
              placeholder="facebook ของผู้กระทำความผิด (ถ้ามี)"
              :readonly="isReadonly ? 'readony' : ''"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="line ของผู้กระทำความผิด (ถ้ามี)">
            <b-form-input
              v-model="clueData.line"
              placeholder="line ของผู้กระทำความผิด (ถ้ามี)"
              :readonly="isReadonly ? 'readony' : ''"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="ig ของผู้กระทำความผิด (ถ้ามี)">
            <b-form-input
              v-model="clueData.instragram"
              placeholder="ig ของผู้กระทำความผิด (ถ้ามี)"
              :readonly="isReadonly ? 'readony' : ''"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="twitter ของผู้กระทำความผิด (ถ้ามี)">
            <b-form-input
              v-model="clueData.twitter"
              placeholder="twitter ของผู้กระทำความผิด (ถ้ามี)"
              :readonly="isReadonly ? 'readony' : ''"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-card
      title="ข้อมูลติดต่อกลับผู้แจ้งเบาะแส"
      body-border-variant="primary"
      body-class="rounded"
    >
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="ชื่อ">
            <b-form-input
              v-model="clueData.fname"
              placeholder="ชื่อ"
              :readonly="isReadonly ? 'readony' : ''"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="นามสกุล">
            <b-form-input
              v-model="clueData.lname"
              placeholder="นามสกุล"
              :readonly="isReadonly ? 'readony' : ''"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="อีเมล">
            <b-form-input
              v-model="clueData.email"
              placeholder="อีเมล"
              :readonly="isReadonly ? 'readony' : ''"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="เบอร์โทร">
            <b-form-input
              v-model="clueData.tel"
              placeholder="เบอร์โทร"
              :readonly="isReadonly ? 'readony' : ''"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </b-tab>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BFormGroup,
  BFormInput,
  BButton,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";

import CompanyAddress from "../../components/CompanyAddress.vue";

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    BFormGroup,
    BFormInput,
    CompanyAddress,
  },
  data() {
    return {};
  },
  props: {
    clueData: {},
    address: {},
    isReadonly: false,
  },
  created() {},
};
</script>

<style lang="scss"></style>
